import { styled } from 'goober';

const SkeletonLoaderContainer = styled('div')`
  animation: skeletonFade 1s ease-in-out infinite forwards;
  background-color: #ebebeb;
  background-image: linear-gradient(90deg, #ebebeb, #d9d9d9, #ebebeb);
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 6px;

  @keyframes skeletonFade {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: calc(200px + 100%) 0;
    }
  }
`;

const Skeleton = ({ style, count = 1, className }) => {
  const loaders = Array.apply(null, Array(Math.ceil(count)));
  return loaders.map((e, index) => {
    return (
      <SkeletonLoaderContainer
        style={style}
        className={className}
        key={index}
      />
    );
  });
};

export default Skeleton;



// WEBPACK FOOTER //
// ./components/salesApp/Skeleton.js